var map = {
	"./bigcartel-icon.svg": 71534,
	"./bigcommerce-icon.svg": 31298,
	"./etsy-icon.svg": 87204,
	"./shopify-icon.svg": 83281,
	"./squarespace-icon.svg": 92448,
	"./woocommerce-icon.svg": 12163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63953;